import styled from "styled-components";

export const ModalHeaderContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
`;

export const CustomModalContainer = styled.div`
  .css-1o31cev > div {
	border: 5px solid lime;
    max-width: 619px !important;
    max-height: 200px !important;
  }
`;

export const CustomModalContentContainer = styled.div`
	display: flex;
	max-height: 72px;
	overflow-y: auto;
	padding-right:	8px;
	flex-wrap: wrap;
	justify-content: center;
	gap:24px;

  &::-webkit-scrollbar {
      width: 6px;
  }

  &::-webkit-scrollbar-track {
      background: ${props => props.theme.colors.highClearGray};
  }

  &::-webkit-scrollbar-thumb {
      background: ${props => props.theme.colors.lighterGray};
      border-radius: 3px;
  }
`
export const CustomModalRemoveContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	justify-content: center;
`;


export const DocumentWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 4px;
    align-items: center;
`

export const DocumentRemoveFileWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`